import { useState } from 'react';

import { Button } from '@opositandopn/ui';
import { LuSwords } from 'react-icons/lu';

import CompetitionImg from '../../../assets/images/d858afff-aad8-414d-aa41-59a43f4715e8.webp';
import { BackdropDialog } from '../../../components/shared/backdrop/BackdropDialog';
import { SectionCard } from '../../../components/shared/section-card/SectionCard';
import { useProfile } from '../../../context/ProfileContext';
import { useAppActions } from '../../../state/appStore';
import { BaseComponentProps } from '../../../types/base-component.types';
import { Game } from './one-to-one/Game';

function ChallengeCard({ className }: BaseComponentProps) {
  const { profile } = useProfile();
  const { setShowGetPremiumPopup } = useAppActions();

  const [showGame, setShowGame] = useState(false);

  const onSelect = () => {
    if (profile.subscription?.isActive) {
      setShowGame(true);
    } else {
      setShowGetPremiumPopup(true);
    }
  };

  return (
    <>
      <SectionCard
        className={className}
        title="Reta a otro opositor en un duelo y gana puntos"
        image={CompetitionImg}
        tooltip="Ganarás 3 puntos si consigues más puntuación que el oponente, 1 si quedáis empate y ningún punto si pierdes."
        button={
          <Button
            variant="outline-primary"
            onClick={onSelect}
            suffixIcon={<LuSwords />}
          >
            Buscar oponente
          </Button>
        }
        icon={<LuSwords />}
      >
        <p>Tendréis que responder a 10 preguntas de cualquier tema.</p>
      </SectionCard>
      <BackdropDialog open={showGame}>
        <Game onQuit={() => setShowGame(false)} />
      </BackdropDialog>
    </>
  );
}

export { ChallengeCard };
